// import React, { useEffect } from 'react';
// import { useSectorIndexes } from '../endpoints/index'; // Adjust the import path as needed
// import BFLoading from './small/BFLoading';
//
// const SectorMiniWidgets = () => {
//   const { data, taxonomyStats, isLoading } = useSectorIndexes('market_cap', 'desc');
//
//   useEffect(() => {
//     if (taxonomyStats) {
//       // console.log('Received taxonomyStats:', taxonomyStats);
//     }
//   }, [taxonomyStats]);
//
//   const getPerformanceColor = (value) => {
//     if (value > 0.2) return 'bg-green-500';
//     if (value < -0.2) return 'bg-red-500';
//     return 'bg-gray-400'; // Neutral gray color for values between -0.2% and 0.2%
//   };
//
//   const renderWidget = (label, value1, value2, percentage1, percentage2, color1 = 'bg-green-500', color2 = 'bg-red-500') => (
//     <div className="bg-white p-2 m-2 rounded shadow-md">
//       <div className="flex justify-between items-center mb-1">
//         <span className="text-lg font-bold text-gray-700">{label}</span>
//       </div>
//       <div className="flex justify-between items-center mb-1">
//         <span className="text-xs text-gray-700">{`${value1} (${percentage1}%)`}</span>
//         <span className="text-xs text-gray-700">{`${value2} (${percentage2}%)`}</span>
//       </div>
//       <div className="relative w-full h-2 bg-gray-200 mt-1">
//         <div
//           className={`absolute left-0 h-2 ${color1}`}
//           style={{ width: `${percentage1}%` }}
//         ></div>
//         <div
//           className={`absolute right-0 h-2 ${color2}`}
//           style={{ width: `${percentage2}%` }}
//         ></div>
//       </div>
//     </div>
//   );
//
//   if (isLoading) return <BFLoading />;
//
//   if (taxonomyStats) {
//     const totalAdvancing = taxonomyStats.asset_performance_24h_bullish + taxonomyStats.asset_performance_24h_bearish;
//     const total1yHighs = taxonomyStats.asset_1y_high + taxonomyStats.asset_1y_low;
//     const totalSMA50 = taxonomyStats.asset_sma_50d_over + taxonomyStats.asset_sma_50d_under;
//     const totalSMA200 = taxonomyStats.asset_sma_200d_over + taxonomyStats.asset_sma_200d_under;
// 	const totalAdvancing7d = taxonomyStats.asset_performance_7d_bullish + taxonomyStats.asset_performance_7d_bearish;
//     const total1yHighs7d = taxonomyStats.asset_1y_high_7d + taxonomyStats.asset_1y_low_7d;
//     const totalSMA507d = taxonomyStats.asset_sma_50d_over_7d + taxonomyStats.asset_sma_50d_under_7d;
//     const totalSMA2007d = taxonomyStats.asset_sma_200d_over_7d + taxonomyStats.asset_sma_200d_under_7d;
//
//     return (
//       <div className="flex flex-col mb-4">
//         {renderWidget(
//           '24 Hour Advancing / Declining',
//           taxonomyStats.asset_performance_24h_bullish,
//           taxonomyStats.asset_performance_24h_bearish,
//           totalAdvancing ? ((taxonomyStats.asset_performance_24h_bullish / totalAdvancing) * 100).toFixed(1) : 0,
//           totalAdvancing ? ((taxonomyStats.asset_performance_24h_bearish / totalAdvancing) * 100).toFixed(1) : 0,
//           'bg-green-500',
//           'bg-red-500'
//         )}
//         {renderWidget(
//           'Weekly Advancing / Declining',
//           taxonomyStats.asset_performance_7d_bullish,
//           taxonomyStats.asset_performance_7d_bearish,
//           totalAdvancing7d ? ((taxonomyStats.asset_performance_7d_bullish / totalAdvancing7d) * 100).toFixed(1) : 0,
//           totalAdvancing7d ? ((taxonomyStats.asset_performance_7d_bearish / totalAdvancing7d) * 100).toFixed(1) : 0,
//           'bg-green-500',
//           'bg-red-500'
//         )}
//         {renderWidget(
//           '52 week high/low - 24 hours',
//           taxonomyStats.asset_1y_high,
//           taxonomyStats.asset_1y_low,
//           total1yHighs ? ((taxonomyStats.asset_1y_high / total1yHighs) * 100).toFixed(1) : 0,
//           total1yHighs ? ((taxonomyStats.asset_1y_low / total1yHighs) * 100).toFixed(1) : 0
//         )}
//         {renderWidget(
//           '52 week high/low - Weekly',
//           taxonomyStats.asset_1y_high_7d,
//           taxonomyStats.asset_1y_low_7d,
//           total1yHighs7d ? ((taxonomyStats.asset_1y_high_7d / total1yHighs7d) * 100).toFixed(1) : 0,
//           total1yHighs7d ? ((taxonomyStats.asset_1y_low_7d / total1yHighs7d) * 100).toFixed(1) : 0
//         )}
//         {renderWidget(
//           'Above/Below SMA50 - 24 hours',
//           taxonomyStats.asset_sma_50d_over,
//           taxonomyStats.asset_sma_50d_under,
//           totalSMA50 ? ((taxonomyStats.asset_sma_50d_over / totalSMA50) * 100).toFixed(1) : 0,
//           totalSMA50 ? ((taxonomyStats.asset_sma_50d_under / totalSMA50) * 100).toFixed(1) : 0
//         )}
//         {renderWidget(
//           'Above/Below SMA50 - Weekly',
//           taxonomyStats.asset_sma_50d_over_7d,
//           taxonomyStats.asset_sma_50d_under_7d,
//           totalSMA507d ? ((taxonomyStats.asset_sma_50d_over_7d / totalSMA507d) * 100).toFixed(1) : 0,
//           totalSMA507d ? ((taxonomyStats.asset_sma_50d_under_7d / totalSMA507d) * 100).toFixed(1) : 0
//         )}
//         {renderWidget(
//           'Above/Below SMA200 - 24 hours',
//           taxonomyStats.asset_sma_200d_over,
//           taxonomyStats.asset_sma_200d_under,
//           totalSMA200 ? ((taxonomyStats.asset_sma_200d_over / totalSMA200) * 100).toFixed(1) : 0,
//           totalSMA200 ? ((taxonomyStats.asset_sma_200d_under / totalSMA200) * 100).toFixed(1) : 0
//         )}
//         {renderWidget(
//           'Above/Below SMA200 - Weekly',
//           taxonomyStats.asset_sma_200d_over_7d,
//           taxonomyStats.asset_sma_200d_under_7d,
//           totalSMA2007d ? ((taxonomyStats.asset_sma_200d_over_7d / totalSMA2007d) * 100).toFixed(1) : 0,
//           totalSMA2007d ? ((taxonomyStats.asset_sma_200d_under_7d / totalSMA2007d) * 100).toFixed(1) : 0
//         )}
//       </div>
//     );
//   }
//
//   return <div>No data available</div>;
// };
//
// export default SectorMiniWidgets;
import React, { useEffect } from 'react';
import { useSectorIndexes } from '../endpoints/index'; // Adjust the import path as needed
import BFLoading from './small/BFLoading';

const SectorMiniWidgets = () => {
  const { data, taxonomyStats, isLoading } = useSectorIndexes('market_cap', 'desc');

  useEffect(() => {
    if (taxonomyStats) {
      // console.log('Received taxonomyStats:', taxonomyStats);
    }
  }, [taxonomyStats]);

  const getPerformanceColor = (value) => {
    if (value > 0.2) return 'bg-green-500';
    if (value < -0.2) return 'bg-red-500';
    return 'bg-gray-400'; // Neutral gray color for values between -0.2% and 0.2%
  };

  const renderWidget = (label, value1, value2, percentage1, percentage2, color1 = 'bg-green-500', color2 = 'bg-red-500') => (
    <div className="bg-white p-2 m-2 rounded shadow-md">
      <div className="flex justify-between items-center mb-1">
        <span className="text-lg font-bold text-gray-700">{label}</span>
      </div>
      <div className="flex justify-between items-center mb-1">
        <span className="text-xs text-gray-700">{`${value1} (${percentage1}%)`}</span>
        <span className="text-xs text-gray-700">{`${value2} (${percentage2}%)`}</span>
      </div>
      <div className="relative w-full h-2 bg-gray-200 mt-1">
        <div
          className={`absolute left-0 h-2 ${color1}`}
          style={{ width: `${percentage1}%` }}
        ></div>
        <div
          className={`absolute right-0 h-2 ${color2}`}
          style={{ width: `${percentage2}%` }}
        ></div>
      </div>
    </div>
  );

  if (isLoading) return <BFLoading />;

  if (taxonomyStats) {
    // 24-hour calculations
    const totalAdvancing = taxonomyStats.asset_performance_24h_bullish + taxonomyStats.asset_performance_24h_bearish;
    const total1yHighs = taxonomyStats.asset_1y_high + taxonomyStats.asset_1y_low;
    const totalSMA50 = taxonomyStats.asset_sma_50d_over + taxonomyStats.asset_sma_50d_under;
    const totalSMA200 = taxonomyStats.asset_sma_200d_over + taxonomyStats.asset_sma_200d_under;

    // Weekly calculations
    const totalAdvancing7d = taxonomyStats.asset_performance_7d_bullish + taxonomyStats.asset_performance_7d_bearish;
    const total1yHighs7d = taxonomyStats.asset_1y_high_7d + taxonomyStats.asset_1y_low_7d;
    const totalSMA507d = taxonomyStats.asset_sma_50d_over_7d + taxonomyStats.asset_sma_50d_under_7d;
    const totalSMA2007d = taxonomyStats.asset_sma_200d_over_7d + taxonomyStats.asset_sma_200d_under_7d;

    // 24-hour widgets
    const dailyWidgets = [
      {
        label: 'Advancing / Declining',
        value1: taxonomyStats.asset_performance_24h_bullish,
        value2: taxonomyStats.asset_performance_24h_bearish,
        percentage1: totalAdvancing ? ((taxonomyStats.asset_performance_24h_bullish / totalAdvancing) * 100).toFixed(1) : 0,
        percentage2: totalAdvancing ? ((taxonomyStats.asset_performance_24h_bearish / totalAdvancing) * 100).toFixed(1) : 0
      },
      {
        label: '52 Week High/Low',
        value1: taxonomyStats.asset_1y_high,
        value2: taxonomyStats.asset_1y_low,
        percentage1: total1yHighs ? ((taxonomyStats.asset_1y_high / total1yHighs) * 100).toFixed(1) : 0,
        percentage2: total1yHighs ? ((taxonomyStats.asset_1y_low / total1yHighs) * 100).toFixed(1) : 0
      },
      {
        label: 'Above/Below SMA50',
        value1: taxonomyStats.asset_sma_50d_over,
        value2: taxonomyStats.asset_sma_50d_under,
        percentage1: totalSMA50 ? ((taxonomyStats.asset_sma_50d_over / totalSMA50) * 100).toFixed(1) : 0,
        percentage2: totalSMA50 ? ((taxonomyStats.asset_sma_50d_under / totalSMA50) * 100).toFixed(1) : 0
      },
      {
        label: 'Above/Below SMA200',
        value1: taxonomyStats.asset_sma_200d_over,
        value2: taxonomyStats.asset_sma_200d_under,
        percentage1: totalSMA200 ? ((taxonomyStats.asset_sma_200d_over / totalSMA200) * 100).toFixed(1) : 0,
        percentage2: totalSMA200 ? ((taxonomyStats.asset_sma_200d_under / totalSMA200) * 100).toFixed(1) : 0
      }
    ];

    // Weekly widgets
    const weeklyWidgets = [
      {
        label: 'Advancing / Declining',
        value1: taxonomyStats.asset_performance_7d_bullish,
        value2: taxonomyStats.asset_performance_7d_bearish,
        percentage1: totalAdvancing7d ? ((taxonomyStats.asset_performance_7d_bullish / totalAdvancing7d) * 100).toFixed(1) : 0,
        percentage2: totalAdvancing7d ? ((taxonomyStats.asset_performance_7d_bearish / totalAdvancing7d) * 100).toFixed(1) : 0
      },
      {
        label: '52 Week High/Low',
        value1: taxonomyStats.asset_1y_high_7d,
        value2: taxonomyStats.asset_1y_low_7d,
        percentage1: total1yHighs7d ? ((taxonomyStats.asset_1y_high_7d / total1yHighs7d) * 100).toFixed(1) : 0,
        percentage2: total1yHighs7d ? ((taxonomyStats.asset_1y_low_7d / total1yHighs7d) * 100).toFixed(1) : 0
      },
      {
        label: 'Above/Below SMA50',
        value1: taxonomyStats.asset_sma_50d_over_7d,
        value2: taxonomyStats.asset_sma_50d_under_7d,
        percentage1: totalSMA507d ? ((taxonomyStats.asset_sma_50d_over_7d / totalSMA507d) * 100).toFixed(1) : 0,
        percentage2: totalSMA507d ? ((taxonomyStats.asset_sma_50d_under_7d / totalSMA507d) * 100).toFixed(1) : 0
      },
      {
        label: 'Above/Below SMA200',
        value1: taxonomyStats.asset_sma_200d_over_7d,
        value2: taxonomyStats.asset_sma_200d_under_7d,
        percentage1: totalSMA2007d ? ((taxonomyStats.asset_sma_200d_over_7d / totalSMA2007d) * 100).toFixed(1) : 0,
        percentage2: totalSMA2007d ? ((taxonomyStats.asset_sma_200d_under_7d / totalSMA2007d) * 100).toFixed(1) : 0
      }
    ];

    return (
      <div className="mb-4">
        {/* Mobile/Tablet - Stack vertically */}
        <div className="block lg:hidden">
          <div className="mb-4">
            <h3 className="text-xl font-bold text-gray-800 mb-2 px-2">24 Hour Metrics</h3>
            <div className="flex flex-col">
              {dailyWidgets.map((widget, index) => (
                <div key={`daily-${index}`}>
                  {renderWidget(
                    widget.label,
                    widget.value1,
                    widget.value2,
                    widget.percentage1,
                    widget.percentage2
                  )}
                </div>
              ))}
            </div>
          </div>
          <div className="mb-4">
            <h3 className="text-xl font-bold text-gray-800 mb-2 px-2">Weekly Metrics</h3>
            <div className="flex flex-col">
              {weeklyWidgets.map((widget, index) => (
                <div key={`weekly-${index}`}>
                  {renderWidget(
                    widget.label,
                    widget.value1,
                    widget.value2,
                    widget.percentage1,
                    widget.percentage2
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Desktop - Two columns */}
        <div className="hidden lg:flex lg:space-x-4">
          <div className="flex-1">
            <h3 className="text-xl font-bold text-gray-800 mb-2 px-2">24 Hour Metrics</h3>
            <div className="flex flex-col">
              {dailyWidgets.map((widget, index) => (
                <div key={`daily-desktop-${index}`}>
                  {renderWidget(
                    widget.label,
                    widget.value1,
                    widget.value2,
                    widget.percentage1,
                    widget.percentage2
                  )}
                </div>
              ))}
            </div>
          </div>
          <div className="flex-1">
            <h3 className="text-xl font-bold text-gray-800 mb-2 px-2">Weekly Metrics</h3>
            <div className="flex flex-col">
              {weeklyWidgets.map((widget, index) => (
                <div key={`weekly-desktop-${index}`}>
                  {renderWidget(
                    widget.label,
                    widget.value1,
                    widget.value2,
                    widget.percentage1,
                    widget.percentage2
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  }

  return <div>No data available</div>;
};

export default SectorMiniWidgets;
